import { React, useEffect, useState } from "react";
import FormAccordion from "../../../components/Form/FormAccordion";
import { CustomDateField } from "../../../components/Form/FormComponents";
import { TextAreaField } from "../../lease/partials/FormComponents";
import { Input, DataListInput } from "./Input";
import { ProductFormWrapper, ButtonGroup, Button, Formgroup } from "./ProductForm.styled";
import { CustomSelectField } from "../../lease/partials/FormComponents";
import { InputData } from "./InputData";
import thrashIcon from "../../../assets/icons/trash.svg";
import saveIcon from "../../../assets/icons/Edit-Square.svg";
import editIcon from "../../../assets/icons/coloredEdit.svg";
import Parse from "../../../api/ApiConfig";
import { useParams, useNavigate } from "react-router";
import { toast } from "react-toastify";
import { getFormattedDate } from "../../../utils/DateUtils";
import {
	fetchAllCategories,
	fetchSubCategories,
	fetchBrands,
	fetchModels,
	formatTextField,
} from "../ProductUtils/CategoriesUtils";
import { formatInput } from "../ProductUtils/utils";
import { canPerformAction } from "../../../utils/UserAuth";
import { shelfLife } from "../../../Constants";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../../redux/AppSlice";
import ConfirmModal from "../../../components/ConfirmModal";
import { MaintenanceScheduleOptions } from "../../../Constants";

/* eslint-disable react/prop-types */
function SingleProductForm({
	setProductName,
	setProductPrice,
	setImagesUrl,
	isFormSaved,
	setIsFormSaved,
	parseImage,
	ProductForm,
	SetProductForm,
}) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [confirmModal, setConfirmModal] = useState(false);
	const [modalText, setModalText] = useState("");
	// const [tags, setTags] = useState([]);
	const [allCategories, setAllCategories] = useState([]);
	const [subcategoryOptions, setSubcategoryOptions] = useState([]);
	const [brandOptions, setBrandOptions] = useState([]);
	const [modelOptions, setModelOptions] = useState([]);
	let { productId } = useParams();

	//fetch product details on page load
	useEffect(() => {
		getProductDetails();
		fetchAllCategories()
			.then((categories) => {
				setAllCategories(categories);
			})
			.catch((error) => {
				console.log(error.message);
				toast.error("Unable to fetch categories data");
			});
	}, []);

	//track changes for mileage difference
	useEffect(() => {
		if (ProductForm?.lastMileage && ProductForm?.currentMileage) {
			const mileageDifference =
				parseInt(ProductForm?.currentMileage.replaceAll(",", "")) -
				parseInt(ProductForm?.lastMileage.replaceAll(",", ""));
			// console.log(mileageDifference);
			SetProductForm((prevData) => {
				return {
					...prevData,
					mileageVariance: mileageDifference,
				};
			});
			return;
		} else if (ProductForm?.lastMileage && !ProductForm?.currentMileage) {
			SetProductForm({ ...ProductForm, mileageVariance: 0 });
		}
	}, [ProductForm?.lastMileage, ProductForm?.currentMileage]);

	const getProductDetails = async () => {
		const Products = Parse.Object.extend("Products");
		const query = new Parse.Query(Products);
		query.equalTo("objectId", productId);

		try {
			const products = await query.find();
			if (products.length <= 0) {
				toast.error("Product not found");
				return;
			}

			SetProductForm((prev) => {
				return {
					...prev,
					category: products[0].attributes.category,
					subCategory: products[0].attributes.subCategory,
					productName: products[0].attributes.productName,
					shelfLife: products[0].attributes.shelfLife,
					admin: products[0].attributes.admin,
					amount: products[0].attributes.amount,
					totalUnits: products[0].attributes.totalUnits,
					availableUnits: products[0].attributes.availableUnits,
					image: products[0].attributes.image,
					color: products[0].attributes.color,
					condition: products[0].attributes.condition,
					brand: products[0].attributes.brand,
					model: products[0].attributes.model,
					year: products[0].attributes.year,
					description: products[0].attributes.description,
					keyFeatures: products[0].attributes.keyFeatures,
					specifications: products[0].attributes.specifications,
					date: getFormattedDate(products[0].createdAt),
					lastMaintenanceDate: {
						__type: "Date",
						iso: new Date(products[0].attributes.lastMaintenanceDate + ":00Z").toISOString(),
					},
					maintenanceDuration: products[0].attributes.maintenanceDuration,
					lastMileage: products[0].attributes.lastMileage,
					currentMileage: products[0].attributes.currentMileage,
					mileageVariance: products[0].attributes.mileageVariance,
					approve: products[0].attributes.approve,
					pickupAddress: products[0]?.attributes?.pickupAddress,
				};
			});

			// setTags(products[0].attributes.tags || []);
			setProductName(products[0].attributes.productName);
			setProductPrice(products[0].attributes.amount);

			setImagesUrl((prevData) => {
				return {
					...prevData,
					firstImageUrl: products[0].attributes.image,
					secondImageUrl: products[0].attributes.secondImage,
					thirdImageUrl: products[0].attributes.thirdImage,
				};
			});
		} catch (error) {
			toast.error(error);
		}
	};

	const getSubcategories = (e) => {
		const selectedCategory = e.target.value;
		fetchSubCategories(selectedCategory)
			.then((subcategories) => {
				//categories without sub categories
				if (subcategories[0].name === "") {
					toast.error("Sub categories not available");
					return;
				} else {
					setSubcategoryOptions(subcategories);
					SetProductForm({ ...ProductForm, category: selectedCategory }); //set value to form state
				}
			})
			.catch((error) => {
				console.log(error.message);
				toast.error("Unable to fetch subcategories data");
			});
	};

	const getBrands = (e) => {
		const index = e.target.selectedIndex;
		const selectedSubcat = subcategoryOptions[index - 1];
		if (!selectedSubcat) {
			console.log(selectedSubcat);
			toast.error("Unable to fetch list of brands");
			SetProductForm({
				...ProductForm,
				subCategory: selectedSubcat.name,
				brand: "",
				model: "",
			});
			setModelOptions([]);
			setBrandOptions([]);
			return;
		}
		SetProductForm({
			...ProductForm,
			subCategory: selectedSubcat.name,
			brand: "",
			model: "",
		});
		setModelOptions([]);
		setBrandOptions([]);

		fetchBrands(selectedSubcat.id)
			.then((brands) => {
				if (brands.length <= 0) {
					SetProductForm({
						...ProductForm,
						subCategory: selectedSubcat.name,
						brand: "",
						model: "",
					});
					setModelOptions([]);
					setBrandOptions([]);
					toast.error("Brands not available");
					return;
				}
				//remove id, since it's only catId we need for models
				const modifiedBrands = brands.map(({ name, catId }) => ({
					name,
					id: catId,
				}));
				setBrandOptions(modifiedBrands);
				return;
			})
			.catch((error) => {
				setModelOptions([]);
				setBrandOptions([]);
				console.log(error.message);
				toast.error("Unable to fetch list of brands");
			});
	};

	const getModels = (e) => {
		const index = e.target.selectedIndex;
		if (index === 0) {
			SetProductForm({ ...ProductForm, brand: "" });
			return;
		}
		// console.log(index);
		const selectedBrand = brandOptions[index - 1]; //get index of selected option as all the options have the same id
		SetProductForm({ ...ProductForm, brand: selectedBrand.name, model: "" });
		fetchModels(selectedBrand.name, selectedBrand.id)
			.then((models) => {
				if (models[0].name === "") {
					toast.error("Model not available");
					setModelOptions([]);
					return;
				} else {
					setModelOptions(models);
				}
			})
			.catch((error) => {
				console.log(error.message);
				setModelOptions([]);
				toast.error("Unable to fetch list of models");
			});
	};

	const handleModels = (e) => {
		if (e.target.value === null) {
			return;
		}
		SetProductForm({ ...ProductForm, model: e.target.value });
		// console.log(ProductForm)
	};

	// console.log(ProductForm)

	//update product 		//fetch and update
	function updateProduct() {
		dispatch(setLoadingState(true));
		let requiredFields;
		if (ProductForm.category === "Vehicle") {
			requiredFields = [
				"productName",
				"shelfLife",
				"admin",
				"category",
				"subCategory",
				"amount",
				"brand",
				"model",
				"year",
				"totalUnits",
				"availableUnits",
				"condition",
				"color",
				"description",
				"keyFeatures",
				"specifications",
				"currentMileage",
				"lastMileage",
				// "mileageVariance",
				"lastMaintenanceDate",
				"maintenanceDuration",
			];
		} else {
			requiredFields = [
				"productName",
				"shelfLife",
				"category",
				"subCategory",
				"amount",
				"brand",
				"model",
				"year",
				"totalUnits",
				"availableUnits",
				"condition",
				"color",
				"description",
				"keyFeatures",
				"specifications",
				"pickupAddress",
			];
		}

		//check if any of the product field is empty, if yes return as an empty field

		const emptyFields = requiredFields.filter((field) => !ProductForm[field]);
		if (emptyFields.length > 0) {
			// Handle validation error
			console.log(emptyFields.join(", "));
			toast.error("Please ensure you fill all required fields before clicking on update");
			dispatch(setLoadingState(false));
			return;
		}
		const Products = Parse.Object.extend("Products");
		const query = new Parse.Query(Products);

		query.get(productId).then(
			(product) => {
				const updatedProductForm = {
					...ProductForm,
					totalUnits: parseInt(ProductForm?.totalUnits),
					availableUnits: parseInt(ProductForm?.availableUnits),
					shelfLife: ProductForm?.shelfLife,
					description: ProductForm?.description ? formatTextField(ProductForm?.description) : "",
					keyFeatures: ProductForm?.keyFeatures ? formatTextField(ProductForm?.keyFeatures) : "",
					specifications: ProductForm?.specifications ? formatTextField(ProductForm?.specifications) : "",
					amount: ProductForm?.amount?.replaceAll(",", ""),
					image: parseImage.firstImage._url,
					secondImage: parseImage.secondImage._url,
					thirdImage: parseImage.thirdImage._url,
					tags: [],
					lastMaintenanceDate: ProductForm?.lastMaintenanceDate,
					maintenanceDuration: ProductForm?.maintenanceDuration,
					lastMileage: ProductForm?.lastMileage.replaceAll(",", ""),
					currentMileage: ProductForm?.currentMileage.replaceAll(",", ""),
					mileageVariance: parseInt(ProductForm?.mileageVariance),
					pickupAddress: ProductForm?.pickupAddress,
				};

				console.log(updatedProductForm);

				product.save(updatedProductForm).then(
					(prod) => {
						dispatch(setLoadingState(false));
						toast.success("Product updated successfully,check product table to see the updated list");
						navigate("/products");
						return prod.save();
					},
					(error) => {
						dispatch(setLoadingState(false));
						console.log(error);
						toast.error(error, "Unable to update product details, please try again");
					}
				);
			},
			(error) => {
				dispatch(setLoadingState(false));
				toast.error(error);
			}
		);
	}

	//delete product
	function deleteProduct() {
		const Products = Parse.Object.extend("Products");
		let query = new Parse.Query(Products);
		query
			.get(productId)
			.then((product) => {
				return product.destroy();
			})
			.then((deletedObject) => {
				toast.success(
					"Product deleted successfully, Check products table to see the updated list",
					deletedObject
				);
				navigate("/products");
			})
			.catch((error) => {
				toast.error(error, "unable to delete product, please try again");
			});
	}

	//handle changes in input field
	function handleChange(event) {
		const { name, value } = event.target;
		if (name === "lastMaintenanceDate") {
			SetProductForm((prevData) => {
				return {
					...prevData,
					[name]: { __type: "Date", iso: new Date(value + ":00Z").toISOString() },
				};
			});
			return;
		}

		SetProductForm((prevData) => {
			return {
				...prevData,
				[name]: value,
			};
		});
	}

	//handle tags input
	// function handleKeyDown(e) {
	// 	if (e.key !== "Enter") return;
	// 	const value = e.target.value;
	// 	if (!value.trim()) return;
	// 	setTags([...tags, value]);
	// 	e.target.value = "";
	// }

	//remove items from tag input
	// function RemoveTag(index) {
	// 	setTags(tags.filter((el, i) => i !== index));
	// }

	//handle dialog box
	const setModal = (status) => {
		setConfirmModal(true);
		if (status === "update") {
			setModalText({
				header: "Update Product",
				desc: "Are you sure you want to update this product?",
				btnText: "Yes, Update",
				status: "update",
			});
		} else {
			setModalText({
				header: "Delete Product",
				desc: "Are you sure you want to delete this product?",
				btnText: "Yes, Delete",
				status: "delete",
			});
		}
	};

	const handleAction = (status) => {
		if (status === "update") {
			updateProduct();
		} else {
			deleteProduct();
		}
	};

	const handleAmount = (e) => {
		const { name, value } = e.target;
		SetProductForm((prevData) => {
			return {
				...prevData,
				[name]: formatInput(value),
			};
		});
	};
	// console.log(InputData);
	return (
		<FormAccordion title='Product Information' open={true}>
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: modalText?.header,
						desc: modalText?.desc,
						btnText: modalText?.btnText,
					}}
					handleDeleteAction={() => handleAction(modalText?.status)}
				/>
			)}
			<ProductFormWrapper>
				{InputData.map((item) => {
					if (item.name === "date") {
						return (
							<Input
								key={item.id}
								status={true}
								value={ProductForm[item.name].toUpperCase() || ""}
								title={item.title}
								handleChange={handleChange}
								type={item.type}
								name={item.name}
							/>
						);
					} else if (item.name === "admin") {
						return (
							<Input
								key={item.id}
								value={ProductForm[item.name] || ""}
								title={item.title}
								handleChange={handleChange}
								type={item.type}
								name={item.name}
								status={true}
							/>
						);
					} else if (item.name === "category") {
						// console.log(ProductForm)
						return (
							<Formgroup key={item.id}>
								<label>CATEGORY</label>
								<CustomSelectField
									key={item.id}
									name={item.title}
									value={ProductForm.category}
									handleChange={getSubcategories}
									options={allCategories}
									isEditable={!isFormSaved}
								/>
							</Formgroup>
						);
					} else if (item.name === "sub-category") {
						return (
							<Formgroup key={item.id}>
								<label>SUB-CATEGORY</label>
								<CustomSelectField
									key={item.id}
									name={item.title}
									handleChange={getBrands}
									value={ProductForm.subCategory}
									options={subcategoryOptions.length > 0 ? subcategoryOptions : [ProductForm.subCategory]}
									isEditable={!isFormSaved}
								/>
							</Formgroup>
						);
					} else if (item.name === "brand") {
						return (
							<Formgroup key={item.id}>
								<label>BRAND</label>
								<CustomSelectField
									key={item.id}
									name={item.title}
									value={ProductForm.brand}
									options={brandOptions.length > 0 ? brandOptions : [ProductForm.brand]}
									handleChange={getModels}
									isEditable={!isFormSaved}
								/>
							</Formgroup>
						);
					} else if (item.name === "model") {
						return (
							<Formgroup key={item.id}>
								<label>MODEL</label>
								<CustomSelectField
									key={item.id}
									name={item.title}
									value={ProductForm.model}
									options={modelOptions.length > 0 ? modelOptions : [ProductForm.model]}
									handleChange={handleModels}
									isEditable={!isFormSaved}
								/>
							</Formgroup>
						);
					} else if (item.name === "amount") {
						return (
							<Input
								key={item.id}
								value={formatInput(ProductForm[item.name]) || ""}
								title={item.title}
								handleChange={handleAmount}
								type={item.type}
								name={item.name}
								status={isFormSaved}
							/>
						);
					} else if (item.name === "shelfLife") {
						return (
							<DataListInput
								key={item.id}
								title={item.title}
								name={item.name}
								options={shelfLife}
								handleChange={handleChange}
								value={ProductForm[item.name] || ""}
								status={isFormSaved}
							/>
						);
					} else {
						return (
							<Input
								key={item.id}
								value={ProductForm[item.name] || ""}
								title={item.title}
								handleChange={handleChange}
								type={item.type}
								name={item.name}
								status={isFormSaved}
							/>
						);
					}
				})}
			</ProductFormWrapper>

			{ProductForm.category === "Vehicle" && (
				<FormAccordion title='Maintenance Schedule' open={true}>
					<div className='grid grid-cols-2 gap-3'>
						<Formgroup>
							<label>LAST MAINTENANCE DATE</label>
							<CustomDateField
								name='lastMaintenanceDate'
								value={ProductForm?.lastMaintenanceDate?.iso?.substring(0, 16) || ""}
								handleChange={handleChange}
								isEditable={!isFormSaved}
							/>
						</Formgroup>
						<DataListInput
							title={"MAINTENANCE DURATION"}
							name={"maintenanceDuration"}
							options={MaintenanceScheduleOptions}
							handleChange={handleChange}
							value={ProductForm?.maintenanceDuration || ""}
							status={isFormSaved}
						/>

						<Input
							value={ProductForm?.lastMileage || ""}
							title={"LAST MILEAGE UPON MAINTENANCE( KM )"}
							handleChange={handleAmount}
							type={"text"}
							name={"lastMileage"}
							status={isFormSaved}
						/>

						<Input
							value={ProductForm?.currentMileage || ""}
							title={"CURRENT MILEAGE(KM)"}
							handleChange={handleAmount}
							type={"text"}
							name={"currentMileage"}
							status={isFormSaved}
						/>

						<Input
							value={ProductForm.mileageVariance || ""}
							title={"MILEAGE VARIANCE(KM)"}
							type={"number"}
							name={"mileageVariance"}
							status={true}
						/>
					</div>
				</FormAccordion>
			)}

			<FormAccordion title='Product description' open={true}>
				<div className='form-group'>
					<TextAreaField
						name='description'
						handleChange={handleChange}
						isEditable={!isFormSaved}
						value={ProductForm.description?.replace(/;/g, "\n")}
					/>
				</div>
			</FormAccordion>

			<FormAccordion title='Key features'>
				<div className='form-group'>
					<TextAreaField
						name='keyFeatures'
						isEditable={!isFormSaved}
						handleChange={handleChange}
						value={
							isFormSaved
								? ProductForm.keyFeatures?.replace(/;/g, "<br/>")
								: ProductForm.keyFeatures?.replace(/;/g, "\n")
						}
					/>
				</div>
			</FormAccordion>

			<FormAccordion title='Product specifications'>
				<div className='form-group'>
					<TextAreaField
						name='specifications'
						isEditable={!isFormSaved}
						handleChange={handleChange}
						value={
							isFormSaved
								? ProductForm.specifications?.replace(/;/g, "<br/>")
								: ProductForm.specifications?.replace(/;/g, "\n")
						}
					/>
				</div>
			</FormAccordion>

			{canPerformAction("edit", "products") && (
				<ButtonGroup>
					{isFormSaved ? (
						<Button
							type='submit'
							color='#006770'
							border='true'
							backgroundcolor='#ffffff'
							onClick={() => setIsFormSaved(false)}>
							<img src={editIcon} />
							<p>Edit Details</p>
						</Button>
					) : (
						<Button
							type='submit'
							onClick={() => setModal("update")}
							color='#ffffff'
							backgroundcolor='#003A50'>
							<img src={saveIcon} />
							<p>Update</p>
						</Button>
					)}

					<Button type='button' onClick={() => setModal("delete")} backgroundcolor='#FF7878' color='#ffffff'>
						<img src={thrashIcon} />
						<p>Delete</p>
					</Button>
				</ButtonGroup>
			)}
		</FormAccordion>
	);
}

export default SingleProductForm;
